// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2o_Kw","header":"styles_header__2Do3z","body":"styles_body__3tAkZ"};